import { render, staticRenderFns } from "./AboutModal.vue?vue&type=template&id=1f5d2bad&"
import script from "./AboutModal.vue?vue&type=script&lang=js&"
export * from "./AboutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports